import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../../services/SellingService";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import CarteCadeauService from "../../../services/MarketingService/CarteCadeauService";
import { useNavigate } from "react-router-dom";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddCarteCadeau = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const navigate = useNavigate();

  const [warehousesSource, setWarehousesSource] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [allProducts, setAllProducts] = useState([{}]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [productBloc, setProductBloc] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [productId, setProductId] = useState(0);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");
  const [estimUnitPrice, setEstimUnitPrice] = useState("");
  const [estimQte, setEstimQte] = useState("");
  const [unitPrice, setUnitPrice] = useState(0);

  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState("");
  const [name, setName] = useState("");
  const [montant, setMontant] = useState(0);

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };
  const getProdcutsByWarehouse = (event) => {
    if (warehouseSourceId !== 0) {
      setProductBloc(true);
      startLoading();
      SellingService.getAllProductsOnSaleForCreatingPack(
        getCurrentUserId(),
        1,
        warehouseSourceId
      )
        .then((response) => {
          if (response.data.success) {
            // console.log("getAllProductsOnSale", response.data.success);
            // setWarehousesSource(response.data.success);
            console.log(response.data.success);
            setAllProducts([{}]);
            // setAvailableProducts(response.data.success);
            response.data.success &&
              response.data.success.map((element) => {
                let exist = false;
                if (allProducts.length !== 0) {
                  for (let index = 0; index < allProducts.length; index++) {
                    if (allProducts[index].value === element.product?.id) {
                      exist = true;
                      break;
                    }
                  }
                }
                let codeProduct = "*";
                if (element.product.productCode !== undefined) {
                  codeProduct = element.product.productCode;
                }
                let barCodeProduct = "*";
                if (element.product.barcode) {
                  barCodeProduct = element.product.barcode;
                }
                let label =
                  codeProduct +
                  "-" +
                  barCodeProduct +
                  "-" +
                  element.product.name;
                if (element.product?.id !== undefined && exist === false) {
                  setAllProducts((oldArray) => [
                    ...oldArray,
                    {
                      value: element.product.id,
                      label: label,
                      customElements: {
                        quantity: element.quantity,
                        tva: element.product.tva,
                        price: element.priceSale,
                        devise: element.devise,
                        typeProduct: element.product.typeProduct,
                      },
                    },
                  ]);
                  setAvailableProducts((oldArray) => [
                    ...oldArray,
                    element.product,
                  ]);
                }
              });
          } else {
            setOpenInfoAlert(true);
            setInfoAlertText("Dépôt est vide");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connexion");
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeSelectedProduct = (selectedOptionn) => {
    console.log("selectedOptionn", selectedOptionn);
    setSelectedOption();
    setProductId(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
    setEstimUnitPrice(selectedOptionn.customElements.price);
    // setEstimQte(selectedOptionn.customElements.quantity);
    // setUnitPrice(selectedOptionn.customElements.price);
  };
  const onChangeStartDate = (event) => {
    setStartDate(event.target.value.concat(":59"));
  };
  const onChangeEndDate = (event) => {
    setEndDate(event.target.value.concat(":59"));
  };
  const handlerChangeName = (event) => {
    setName(event.target.value);
  };
  const onChangeUnitPriceHandler = (event) => {
    setMontant(event.target.value);
  };

  function blocProducts() {
    if (productBloc && warehouseSourceId !== 0) {
      return (
        <div>
          <div class="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>Choisir un produit</label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedOption}
                  onChange={onChangeSelectedProduct}
                  options={allProducts}
                  placeholder={productSelectPlaceHolder}
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div className="col-sm-3">
              <div class="form-group">
                <label>Choisir le libellé </label>
                <input
                  onChange={handlerChangeName}
                  type="text"
                  id="inputClientCompany"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label>Prix</label>
                <input
                  onChange={onChangeUnitPriceHandler}
                  type="number"
                  value={montant}
                  min="0"
                  id="unitPrice"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label htmlFor="inputName">Date début</label>

                <TextField
                  style={{ width: "100%" }}
                  className="col-sm-12"
                  variant="outlined"
                  value={startDate}
                  onChange={onChangeStartDate}
                  id="datetime-local"
                  type="datetime-local"
                  defaultValue="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group">
                <label htmlFor="inputName">Date fin</label>

                <TextField
                  style={{ width: "100%" }}
                  className="col-sm-12"
                  variant="outlined"
                  value={endDate}
                  onChange={onChangeEndDate}
                  id="datetime-local"
                  type="datetime-local"
                  defaultValue="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  const onAddCarteCadeau = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le nom est vide ! ");
    } else {
      let carteCadeauAddModel = {
        name: name,
        idProduct: productId,
        idUser: getCurrentUserId(),
        dateDebut: startDate,
        dateFin: endDate,
        idWarehouse: warehouseSourceId,
        value:montant,
      };
      console.log("carteCadeauAddModel", carteCadeauAddModel);
      startLoading();
      CarteCadeauService.addCarteCadeau(carteCadeauAddModel)
        .then((response) => {
          console.log("response", response.data["success"]);
          if (response.data.success) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/cartesCadeaux`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((e) => {
          console.log("error in allDiscounts", e);
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter une carte cadeau</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">Ajouter une carte cadeau</h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir le dépôt </label>
                        <div className="input-group">
                          <div
                            className="input-group-prepend"
                            style={{ width: "95%" }}
                          >
                            <Select
                              styles={styles}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              defaultValue={selectedOption}
                              onChange={onChangeSelectedWarehouseSource}
                              options={allWarehouseSource}
                              placeholder={warehouseSelectPlaceHolder}
                            />
                          </div>
                          <div className=" input-group-append">
                            <button
                              onClick={getProdcutsByWarehouse}
                              type="button"
                              class="btn btn-dark"
                            >
                              <i class="fas  fa-solid fa-arrow-down"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {blocProducts()}
                </div>
                <div class="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark float-right"
                      onClick={onAddCarteCadeau}
                    >
                      Confirmer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddCarteCadeau);
